import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-589b298a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "pass-gen-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-center text-light-gray mb-6" }, "Password Generator")
], -1))
const _hoisted_3 = { class: "generator-section" }
const _hoisted_4 = { class: "flex flex-row justify-between" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" stroke=\"#A4FFAF\" xmlns=\"http://www.w3.org/2000/svg\" data-v-589b298a><path d=\"M19.8333 15.6333V19.1333C19.8333 23.8 17.9667 25.6667 13.3 25.6667H8.86666C4.19999 25.6667 2.33333 23.8 2.33333 19.1333V14.7C2.33333 10.0333 4.19999 8.16666 8.86666 8.16666H12.3667\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-589b298a></path><path d=\"M19.8333 15.6333H16.1C13.3 15.6333 12.3667 14.7 12.3667 11.9V8.16666L19.8333 15.6333Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-589b298a></path><path d=\"M13.5333 2.33334H18.2\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-589b298a></path><path d=\"M8.16667 5.83334C8.16667 3.89668 9.73001 2.33334 11.6667 2.33334H14.7233\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-589b298a></path><path d=\"M25.6667 9.33334V16.555C25.6667 18.3633 24.1967 19.8333 22.3883 19.8333\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-589b298a></path><path d=\"M25.6667 9.33334H22.1667C19.5417 9.33334 18.6667 8.45834 18.6667 5.83334V2.33334L25.6667 9.33334Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-589b298a></path></svg>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "generator-section" }
const _hoisted_8 = { class: "flex flex-row justify-between items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Character length", -1))
const _hoisted_10 = { class: "text-light-green text-3xl font-bold" }
const _hoisted_11 = { class: "slider-container relative" }
const _hoisted_12 = { class: "pw-settings-checkbox" }
const _hoisted_13 = { class: "checkbox-input-container" }
const _hoisted_14 = { class: "checkbox-input" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Include Uppercase Letters", -1))
const _hoisted_17 = { class: "checkbox-input-container" }
const _hoisted_18 = { class: "checkbox-input" }
const _hoisted_19 = ["checked"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Include Lowercase Letters", -1))
const _hoisted_21 = { class: "checkbox-input-container" }
const _hoisted_22 = { class: "checkbox-input" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Include Numbers", -1))
const _hoisted_25 = { class: "checkbox-input-container" }
const _hoisted_26 = { class: "checkbox-input" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Include Symbols", -1))
const _hoisted_29 = { class: "flex flex-row justify-between rounded bg-dark-gray-500 py-3 my-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray ml-3 uppercase" }, "Strength", -1))
const _hoisted_31 = { class: "flex flex-row" }
const _hoisted_32 = { class: "mr-3 uppercase" }
const _hoisted_33 = { class: "flex flex-row justify-between mr-3 diff-ind-container" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "flex flex-col justify-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-dark-gray-400 font-bold mr-3" }, "Generate", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.8225 4.44751L15.375 9.00001L10.8225 13.5525",
    stroke: "#18171F",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.625 9H15.2475",
    stroke: "#18171F",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopiedModal = _resolveComponent("CopiedModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.passwordCreated? 'text-white':'text-gray','overflow-x-clip'])
          }, _toDisplayString(_ctx.password), 3),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showCopyModal && _ctx.showCopyModal(...args)), ["prevent"])),
            class: "copy-icon pl-2"
          }, _hoisted_6)
        ])
      ]),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.passwordLength), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "slider w-full",
              type: "range",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordLength) = $event)),
              min: "4",
              max: "40",
              step: "1"
            }, null, 512), [
              [_vModelText, _ctx.passwordLength]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "slider-thumb-m",
              type: "range",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordLength) = $event)),
              min: "4",
              max: "40",
              step: "1"
            }, null, 512), [
              [_vModelText, _ctx.passwordLength]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addUpperLetters) = $event)),
                  type: "checkbox",
                  checked: _ctx.addUpperLetters
                }, null, 8, _hoisted_15), [
                  [_vModelCheckbox, _ctx.addUpperLetters]
                ]),
                _hoisted_16
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addLowerLetters) = $event)),
                  class: "",
                  type: "checkbox",
                  checked: _ctx.addLowerLetters
                }, null, 8, _hoisted_19), [
                  [_vModelCheckbox, _ctx.addLowerLetters]
                ]),
                _hoisted_20
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addNumbers) = $event)),
                  class: "",
                  type: "checkbox",
                  checked: _ctx.addNumbers
                }, null, 8, _hoisted_23), [
                  [_vModelCheckbox, _ctx.addNumbers]
                ]),
                _hoisted_24
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addSymbols) = $event)),
                  class: "",
                  type: "checkbox",
                  checked: _ctx.addSymbols
                }, null, 8, _hoisted_27), [
                  [_vModelCheckbox, _ctx.addSymbols]
                ]),
                _hoisted_28
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.passwordDifficulty), 1),
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                  return _createElementVNode("div", {
                    class: _normalizeClass([n <= _ctx.passwordScore? 'str-indicator-filled': 'str-indicator','diff-ind-item']),
                    key: n
                  }, _hoisted_35, 2)
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)), ["prevent"])),
              class: "generate-btn"
            }, _hoisted_39)
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "copy-modal-bar" }, {
      default: _withCtx(() => [
        (_ctx.copyModal)
          ? (_openBlock(), _createBlock(_component_CopiedModal, {
              key: 0,
              "set-module-visible": true,
              onClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copyModal = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}